var _c;
// import { ProGalleryOptions } from './gallery.types';
import { optionsMap, galleryOptions, isInPreset, addPresetOptions, extendNestedOptionsToIncludeOldAndNew, } from 'pro-gallery-lib';
import optionsConverter from './proGalleryOptionsBuilder';
import { PRIVATE_CONTROLLERS } from './controllers/private-controllers';
var getTrue = function () { return true; };
var isNewInfoExperimentOpen = function (experimentalFeatures) { return experimentalFeatures.newInfoElements === true; };
var getIsOldInfo = function (_a, _b, experimentalFeatures) {
    if (isNewInfoExperimentOpen(experimentalFeatures)) {
        return false;
    }
    return true;
};
var getIsNewInfo = function (_a, _b, experimentalFeatures) {
    return isNewInfoExperimentOpen(experimentalFeatures);
};
var settingsOptions = (_c = {},
    _c[optionsMap.layoutParams.navigationArrows
        .verticalAlignment] = getTrue,
    _c[optionsMap.behaviourParams.item.content
        .placementAnimation] = getTrue,
    _c[PRIVATE_CONTROLLERS.VIDEO.VOLUME] = getTrue,
    _c[PRIVATE_CONTROLLERS.INFO
        .ALLOW_TITLE_AND_DESCRIPTION] = getIsOldInfo,
    _c[PRIVATE_CONTROLLERS.INFO.ALLOW_TITLE] = getTrue,
    _c[PRIVATE_CONTROLLERS.INFO.ALLOW_DESCRIPTION] = getTrue,
    _c[PRIVATE_CONTROLLERS.INFO.VERTICAL_PADDING] = getIsOldInfo,
    _c[PRIVATE_CONTROLLERS.INFO.HORIZONTAL_PADDING] = getIsOldInfo,
    _c[PRIVATE_CONTROLLERS.INFO.VERTICAL_ALIGN] = getIsOldInfo,
    _c[PRIVATE_CONTROLLERS.INFO.HORIZONTAL_ALIGN] = getIsOldInfo,
    _c[PRIVATE_CONTROLLERS.INFO
        .EXTERNAL_MASTER_INFO_ENABLED] = getTrue,
    _c[PRIVATE_CONTROLLERS.INFO
        .EXTERNAL_MASTER_INFO_ORDER] = getIsNewInfo,
    _c[PRIVATE_CONTROLLERS.INFO
        .INTERNAL_MASTER_INFO_ENABLED] = getTrue,
    _c[PRIVATE_CONTROLLERS.INFO
        .INTERNAL_MASTER_INFO_ORDER] = getIsNewInfo,
    _c[PRIVATE_CONTROLLERS.FULLSCREEN.ALLOW_TITLE] = getTrue,
    _c[PRIVATE_CONTROLLERS.FULLSCREEN.ALLOW_DESCRIPTION] = getTrue,
    _c[PRIVATE_CONTROLLERS.FULLSCREEN.ALLOW_LINK] = getTrue,
    _c[PRIVATE_CONTROLLERS.FULLSCREEN.EXPAND_INFO_POSITION] = getTrue,
    _c[PRIVATE_CONTROLLERS.FULLSCREEN.SHOW_INFO_BUTTON] = getTrue,
    _c[PRIVATE_CONTROLLERS.FULLSCREEN.ALLOW_FULLSCREEN_EXPAND] = getTrue,
    _c[PRIVATE_CONTROLLERS.FULLSCREEN.LOOP] = getTrue,
    _c[PRIVATE_CONTROLLERS.FULLSCREEN.ALLOW_MAGNIFY_IMAGE] = getTrue,
    _c[PRIVATE_CONTROLLERS.FULLSCREEN.MAGNIFICATION_LEVEL] = getTrue,
    _c[PRIVATE_CONTROLLERS.FULLSCREEN.BACKGROUND_BLUR_FILTER] = getTrue,
    _c[PRIVATE_CONTROLLERS.FULLSCREEN.BACKGROUND_GRAYSCAL_EFILTER] = getTrue,
    _c[PRIVATE_CONTROLLERS.FULLSCREEN.FULLSCREEN_PREVIEW] = getTrue,
    _c[PRIVATE_CONTROLLERS.INFO.WIDTH_IN_PIXEL] = function (opts) {
        var unit = opts.layoutParams.info.sizeUnits;
        return (galleryOptions[optionsMap.layoutParams.info.width].isRelevant(opts, null) && unit === 'PIXEL');
    },
    _c[PRIVATE_CONTROLLERS.INFO.WIDTH_IN_PERCENT] = function (opts) {
        var unit = opts.layoutParams.info.sizeUnits;
        return (galleryOptions[optionsMap.layoutParams.info.width].isRelevant(opts, null) && unit === 'PERCENT');
    },
    _c['OVERLAY'] = function (opts) {
        return galleryOptions[optionsMap.behaviourParams.item.overlay.size].isRelevant(opts, null);
    },
    _c[PRIVATE_CONTROLLERS.OVERLAY.OVERLAY_TYPE] = function (opts) {
        return galleryOptions[optionsMap.behaviourParams.item.overlay.size].isRelevant(opts, null);
    },
    _c[optionsMap.behaviourParams.item.overlay.sizeUnits] = function (opts) {
        var type = opts.controllers.behaviourParams.item.overlay.overlayType;
        return (galleryOptions[optionsMap.behaviourParams.item.overlay.sizeUnits].isRelevant(opts, null) && type === 'PARTIAL');
    },
    _c[PRIVATE_CONTROLLERS.OVERLAY.SIZE_IN_PERCENT] = function (opts) {
        var unit = opts.behaviourParams.item.overlay.sizeUnits;
        var type = opts.controllers.behaviourParams.item.overlay.overlayType;
        return (galleryOptions[optionsMap.behaviourParams.item.overlay.sizeUnits].isRelevant(opts, null) &&
            unit === 'PERCENT' &&
            type === 'PARTIAL');
    },
    _c[PRIVATE_CONTROLLERS.OVERLAY.SIZE_IN_PIXEL] = function (opts) {
        var unit = opts.behaviourParams.item.overlay.sizeUnits;
        var type = opts.controllers.behaviourParams.item.overlay.overlayType;
        return (galleryOptions[optionsMap.behaviourParams.item.overlay.sizeUnits].isRelevant(opts, null) &&
            unit === 'PIXEL' &&
            type === 'PARTIAL');
    },
    _c[optionsMap.behaviourParams.item.overlay.position] = function (opts) {
        var type = opts.controllers.behaviourParams.item.overlay.overlayType;
        return (galleryOptions[optionsMap.behaviourParams.item.overlay.position].isRelevant(opts, null) && type === 'PARTIAL');
    },
    _c[optionsMap.behaviourParams.item.overlay.padding] = function (opts) {
        var type = opts.controllers.behaviourParams.item.overlay.overlayType;
        return (galleryOptions[optionsMap.behaviourParams.item.overlay.padding].isRelevant(opts, null) && type === 'PARTIAL');
    },
    _c[PRIVATE_CONTROLLERS.GALLERY.GALLERY_RATIO_METHOD] = function (_opts) {
        return galleryOptions[optionsMap.layoutParams.structure.galleryRatio.value].isRelevant(_opts, null);
    },
    _c[PRIVATE_CONTROLLERS.GALLERY.GALLERY_RATIO_VALUE] = function (_opts) {
        return (_opts.controllers.layoutParams.structure.galleryRatio.method ===
            'FIXED' &&
            galleryOptions[optionsMap.layoutParams.structure.galleryRatio.value].isRelevant(_opts, null));
    },
    _c);
var isRelevant = function (paramName, settingOptions, enumOption, experimentaFeatures, optionsEnableMap) {
    var _c;
    if (settingOptions === void 0) { settingOptions = {}; }
    if (experimentaFeatures === void 0) { experimentaFeatures = {}; }
    if (optionsEnableMap === void 0) { optionsEnableMap = {}; }
    var newSettingsOptions = optionsConverter(settingOptions).galleryOptions;
    var migratedOptions = extendNestedOptionsToIncludeOldAndNew(newSettingsOptions);
    var options = addPresetOptions(migratedOptions);
    var galleryLayout = options.galleryLayout;
    var optionEnable = (enumOption === undefined || enumOption === null) ? optionsEnableMap[paramName] : optionsEnableMap["".concat(paramName, ".").concat(enumOption)];
    var optionDisabled = optionEnable && optionEnable.enabled === false;
    if (optionDisabled) {
        return false;
    }
    var isRelevantFunc = (settingsOptions === null || settingsOptions === void 0 ? void 0 : settingsOptions[paramName]) || ((_c = galleryOptions[paramName]) === null || _c === void 0 ? void 0 : _c.isRelevant);
    var isRelevantResult = !!isRelevantFunc && isRelevantFunc(options, enumOption, experimentaFeatures);
    if (paramName === optionsMap.layoutParams.structure.galleryLayout) {
        // for some reason the galleryLayout param appear on each preset
        return true;
    }
    if (isInPreset(galleryLayout, paramName)) {
        return false;
    }
    return isRelevantResult;
};
export default isRelevant;
//# sourceMappingURL=isRelevant.js.map